import { Box, ChevronRightIcon } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';
import { WaypointGroup as WaypointGroupModel } from '../mapSettingsConfig';
import WaypointRow from './WaypointRow';

interface WaypointGroupProps {
  group: WaypointGroupModel;
  expanded: boolean;
  onToggleExpanded: (_owningMenu: string) => void;
  selectedLayerTypes: Set<string>;
  onToggleLayer: (_layerName: string) => void;
}

const StyledCard = styled(Box)`
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.line};
`;

const StyledHeader = styled(Box).attrs({ as: 'button', type: 'button' })`
  appearance: none;
  cursor: pointer;
  text-align: left;
`;

/**
 * ChevronRightIcon draws an 8x15 viewBox but sizes itself as a square, so
 * `size` alone stretches it. Constrain the svg to its natural proportions.
 */
const StyledChevron = styled(Box)<{ $expanded: boolean }>`
  transition: transform 200ms ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '90deg' : '0deg')});

  svg {
    width: 9px;
    height: 17px;
  }
`;

/** A collapsible category of marker types. */
const WaypointGroup: FC<WaypointGroupProps> = ({
  group,
  expanded,
  onToggleExpanded,
  selectedLayerTypes,
  onToggleLayer,
}) => (
  <StyledCard
    display="flex"
    flexDirection="column"
    bg="white"
    borderRadius="12px"
    overflow="hidden"
  >
    <StyledHeader
      onClick={() => onToggleExpanded(group.owningMenu)}
      aria-expanded={expanded}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      border="0"
      bg="transparent"
      p="3"
      gap={2.5}
    >
      <Box fontWeight="bold" fontSize="15px" color="black">
        {group.title}
      </Box>
      <StyledChevron
        $expanded={expanded}
        display="flex"
        alignItems="center"
        color="darkgrey"
      >
        <ChevronRightIcon />
      </StyledChevron>
    </StyledHeader>

    {expanded && (
      <Box display="flex" flexDirection="column" pb="2" px={2.5}>
        {group.layers.map((layer) => (
          <WaypointRow
            key={layer.layerName}
            layer={layer}
            checked={selectedLayerTypes.has(layer.layerName)}
            onToggle={onToggleLayer}
          />
        ))}
      </Box>
    )}
  </StyledCard>
);

export default WaypointGroup;
